import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import DashboardWrapper from "../containers/DashboardWrapper";
import { getPlotImageDataByFileName, setCurrentPage } from "../actions";
import ImageMeta from "../components/Viewer/ImageMeta";
import ImageMagnify from "../components/Viewer/ImageMagnify";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 64px)",
    padding: 0,
  },
  shell: {
    maxWidth: 1400,
    margin: "0 auto",
  },
  contentGrid: {
    marginTop: theme.spacing(0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centeredContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  empty: {
    padding: theme.spacing(2),
    color: "#64748b",
  },
}));

const PlotViewer = ({
  setCurrentPage,
  getPlotImageDataByFileName,
  plotViewerImageData,
  plotViewerLoading,
  plotViewerError,
}) => {
  const classes = useStyles();
  const image = plotViewerImageData?.[0];

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    const pathParts = window.location.pathname.split("/");
    const encodedFileName = pathParts[pathParts.length - 1];
    const fileName = decodeURIComponent(encodedFileName);
    if (fileName) {
      getPlotImageDataByFileName(fileName);
    }
  }, [getPlotImageDataByFileName, setCurrentPage]);

  return (
    <DashboardWrapper>
      <div className={classes.root}>
        <div className={classes.shell}>
          <Grid container spacing={0} direction="row" justifyContent="center" className={classes.contentGrid}>
            <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer} style={{ marginTop: 0, marginBottom: 24 }}>
              <ImageMeta viewer={plotViewerImageData} noInput={true} numOfImage={plotViewerImageData?.length} />
            </Grid>
            <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
              {plotViewerLoading ? (
                <div className={classes.empty}>画像データを読み込み中です。</div>
              ) : plotViewerError ? (
                <div className={classes.empty}>{plotViewerError}</div>
              ) : image ? (
                <ImageMagnify viewer={plotViewerImageData} />
              ) : (
                <div className={classes.empty}>該当する画像がありません。</div>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    </DashboardWrapper>
  );
};

PlotViewer.propTypes = {
  setCurrentPage: PropTypes.func.isRequired,
  getPlotImageDataByFileName: PropTypes.func.isRequired,
  plotViewerImageData: PropTypes.array,
  plotViewerLoading: PropTypes.bool,
  plotViewerError: PropTypes.string,
};

const mapStateToProps = (state) => ({
  plotViewerImageData: state.plotViewer.plotViewerImageData,
  plotViewerLoading: state.plotViewer.plotViewerLoading,
  plotViewerError: state.plotViewer.plotViewerError,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPlotImageDataByFileName: (param) => dispatch(getPlotImageDataByFileName(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PlotViewer);
